// ============================================================================
// CENTRAL PRICING CONFIGURATION — single source of truth for every displayed
// rate across the site (Pricing page, homepage preview, hero, FAQs, metadata).
//
// ⚠️ VERIFY BEFORE PUBLISH: confirm every number below against the signed
// Stripe terms and the live Stripe Connect configuration before deploying.
// The customer pays the agreed project amount; applicable fees are deducted
// from the vendor's payout. Payments are processed through Stripe — WorkPay
// provides the project, milestone and approval workflow software.
// ============================================================================

export const CURRENCY = "AED";

export const PRICING = {
  // Domestic-card payment processing — applies to BOTH workflows.
  processing: { pct: 2.9, fixed: 1 },

  // Milestone workflow — additional to payment processing.
  milestone: {
    workpayPct: 1, // additional WorkPay milestone-workflow fee
    vatPct: 5, // VAT charged on the WorkPay fee (5% of the 1%)
    effectivePct: 1.05, // 1% + 5% VAT
    totalPct: 3.95, // effective domestic-card total (2.9 + 1.05)
    fixed: 1,
  },

  // Additional processing charges (Stripe-based) that may apply on top.
  addOns: [
    { label: "International card", pct: 1, note: "non-UAE / international cards" },
    { label: "Currency conversion", pct: 1, note: "when the card currency differs" },
  ],

  otherCharges:
    "Refunds, disputes, chargebacks and optional payout services may involve other charges.",

  // Worked example (AED 10,000) — subject to final fee verification.
  example: {
    amount: 10000,
    simple: { processing: 291, totalFee: 291, payout: 9709 },
    milestone: { processing: 291, workpay: 100, vat: 5, totalFee: 396, payout: 9604 },
    milestoneDelta: 105,
  },
};

export const money = (n) => `${CURRENCY} ${Number(n).toLocaleString("en-AE")}`;

// 2.9% + AED 1
export const SIMPLE_RATE = `${PRICING.processing.pct}% + ${CURRENCY} ${PRICING.processing.fixed}`;
// 3.95% + AED 1
export const MILESTONE_RATE = `${PRICING.milestone.totalPct}% + ${CURRENCY} ${PRICING.milestone.fixed}`;
